<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Medication'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteMedication">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteMedicationDialog",
  emits: ["deleteMedication"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      medication: null,
      name: null,
    };
  },
  methods: {
    show(medication) {
      (async () => {
        this.medication = medication;
        this.name = medication.name;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteMedication() {
      this.$emit("deleteMedication", this.medication);
    },
  },
};
</script>
